import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDatabaseIcon14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1a1 1 0 0 1 1 1v2.602a.995.995 0 0 1-.134.5.982.982 0 0 1 .134.5v2.793a.995.995 0 0 1-.134.5.992.992 0 0 1 .134.5V12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9.395c0-.183.049-.354.134-.502A.982.982 0 0 1 1 8.395V5.602c0-.183.049-.353.134-.5a.993.993 0 0 1-.134-.5V2a1 1 0 0 1 1-1h10Zm0 8.395H2V12h10V9.395Zm0-3.793H2v2.793h10V5.602ZM12 2H2v2.602h10V2Z"
      fill="#666"
    />
    <path
      d="M11 3.5v-1H9v1h2ZM11 7.102v-1H9v1h2ZM11 10.895v-1H9v1h2Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgDatabaseIcon14Px);
export default Memo;
